import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MainLogo from "../images/main-logo.svg";

export default function PageTransition() {
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Don't run route-loader logic in Jest.
    if (process.env.NODE_ENV === "test") return;

    setVisible(true);
    let cancelled = false;

    const waitForImagesInMain = () => {
      const imgs = Array.from(document.querySelectorAll("main img"));
      const pending = imgs.filter((img) => !img.complete);
      if (pending.length === 0) return Promise.resolve();
      return Promise.allSettled(
        pending.map(
          (img) =>
            new Promise((resolve) => {
              const done = () => resolve();
              img.addEventListener("load", done, { once: true });
              img.addEventListener("error", done, { once: true });
            })
        )
      );
    };

    const waitForFonts = () => {
      // `document.fonts` isn't supported everywhere; skip if absent.
      if (!document.fonts || !document.fonts.ready) return Promise.resolve();
      return document.fonts.ready.catch(() => undefined);
    };

    // Best-effort "fully rendered": wait for route to paint, then images/fonts.
    const run = async () => {
      // Wait for React to commit the new route DOM and paint it.
      await new Promise((r) => requestAnimationFrame(() => r()));
      await new Promise((r) => requestAnimationFrame(() => r()));

      // Wait for assets that can shift layout.
      await Promise.all([waitForImagesInMain(), waitForFonts()]);

      if (!cancelled) setVisible(false);
    };

    run();

    // Safety: never hang indefinitely (slow network / huge images).
    const safety = window.setTimeout(() => {
      if (!cancelled) setVisible(false);
    }, 4000);

    return () => {
      cancelled = true;
      window.clearTimeout(safety);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  if (!visible) return null;

  return (
    <div className="page-transition" aria-hidden="true">
      <div className="page-transition__inner" role="status" aria-live="polite">
        <img className="page-transition__logo" src={MainLogo} alt="" />
        <div className="page-transition__spinner" />
      </div>
    </div>
  );
}

